module.exports = __webpack_public_path__ + "img/2-personas.225c8d89.png";